import React from 'react';
import { useTranslation } from 'react-i18next';
import LegalLayout from '@/components/LegalLayout';

const SECTIONS = [
  ['h_controller', 'p_controller'],
  ['h_data', 'p_data'],
  ['h_purpose', 'p_purpose'],
  ['h_retention', 'p_retention'],
  ['h_sharing', 'p_sharing'],
  ['h_rights', 'p_rights'],
  ['h_security', 'p_security'],
  ['h_changes', 'p_changes'],
];

export default function PrivacyPolicy({ lang }) {
  const { t } = useTranslation();
  return (
    <LegalLayout lang={lang} tKey="privacy">
      {SECTIONS.map(([h, p]) => (
        <section key={h} className="aq-legal__section">
          <h2>{t(`privacy.${h}`)}</h2>
          <p>{t(`privacy.${p}`)}</p>
        </section>
      ))}
    </LegalLayout>
  );
}
